export const SET_CURRENT_USER: string = "SET_CURRENT_USER";
export const LOGIN_REQUEST: string = "LOGIN_REQUEST";
export const RESET_PASSWORD_REQUEST: string = "RESET_PASSWORD_REQUEST";
export const CLEAR_AUTH: string = "CLEAR_AUTH";
export const LOGOUT_REQUEST: string = "LOGOUT_REQUEST";
export const UPDATE_CURRENT_USER: string = "UPDATE_CURRENT_USER";
export const UPDATE_TOTAL_SERVICES: string = "UPDATE_TOTAL_SERVICES";
